// extracted by mini-css-extract-plugin
module.exports = {"container":"quicklinks-module--container--1Wnue","card":"quicklinks-module--card--28Pqw"};